import Vue from 'vue';
import DesignSystem from 'components-design-system';
import 'components-design-system/dist/system/principal.css';
import Home from '@/pages/Home/Home.vue';
import vuetify from './plugins/vuetify';

Vue.use(DesignSystem);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: h => h(Home),
}).$mount('#transfer-tracking-app-container');
